import Skeleton from "../../../components/Skeleton/Skeleton";
import TableSkeleton from "../../../components/Skeleton/ui/TableSkeleton/TableSkeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <div className="flex flex-col gap-4">
        {/* Balance card */}
        <div className="rounded-xl border border-[#EBEBEB] p-5 flex flex-col gap-4">
          <Skeleton width="220px" height="14px" />
          <Skeleton width="100%" height="40px" borderRadius="0.5rem" />
          <div className="flex items-center justify-between">
            <Skeleton width="60px" height="16px" />
            <Skeleton width="56px" height="16px" />
          </div>
          <Skeleton width="200px" height="36px" />
          <div className="flex gap-3">
            <Skeleton height="44px" borderRadius="0.5rem" className="flex-1" />
            <Skeleton height="44px" borderRadius="0.5rem" className="flex-1" />
          </div>
        </div>

        {/* Cartera card */}
        <div className="rounded-xl border border-[#EBEBEB] p-5 flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <Skeleton width="80px" height="20px" />
            <Skeleton width="20px" height="20px" />
          </div>
          <Skeleton width="180px" height="32px" />
          <Skeleton width="160px" height="14px" />
        </div>

        {/* Banners */}
        <Skeleton width="80%" height="140px" borderRadius="0.75rem" />

        {/* Orders section */}
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <Skeleton width="130px" height="20px" />
            <Skeleton width="20px" height="20px" />
          </div>
          <TableSkeleton numberOfColumns={3} numberOfRows={5} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 h-full min-h-[100vh]">
      <div className="flex gap-6">
        <Skeleton width="467.85px" height="332px" />
        <Skeleton height="332px" className="grow" />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "1rem",
          width: "100%",
          height: "12.675rem",
          marginBottom: "0.5rem",
        }}
      >
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} borderRadius="0.625rem" height="12.675rem" />
        ))}
      </div>

      <div className="flex flex-col gap-4 grow">
        <Skeleton width="13rem" height="34px" />
        <TableSkeleton numberOfColumns={3} numberOfRows={10} />
      </div>
    </div>
  );
};

export default PageSkeleton;
